<template>
  <v-dialog v-model="showPdfDialog" scrollable max-width="1264px">
    <v-card v-if="Object.keys(item).length > 0">
      <v-card-title class="primary white--text">
        <h3 class="headline">{{ item.title }}</h3>
        <v-spacer/>
        <v-btn text small fab @click="close()">
          <v-icon color="white">close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text style="height: 800px;">
        <iframe
          id="theFrame"
          frameborder="1"
          height="100%"
          width="100%"
          name="theFrame"
          :src="iframeSrc"
          type="application/pdf"
        >
          This browser does not support PDFs. Please download the PDF to view it:
          <a :href="item.pdfLink">Download PDF</a>
        </iframe>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import pdfobject from 'pdfobject';

export default {
  name: 'PdfDialog',
  data() {
    return {
      showPdfDialog: false,
      item: {},
    };
  },
  computed: {
    iframeSrc() {
      if (Object.keys(this.item).length > 0) {
        return `${this.item.pdfLink}#zoom=100`;
      }
      return '/';
    },
    pdfSupported() {
      return pdfobject.supportsPDFs;
    },
  },
  methods: {
    close() {
      this.showPdfDialog = false;
      this.item = {};
    },
  },
  mounted() {
    this.$eventBus.$on('show-pdf-dialog', (item) => {
      if (!this.pdfSupported) {
        window.open(item.pdfLink, '_blank');
      } else {
        this.item = item;
        this.$nextTick(() => {
          this.showPdfDialog = true;
        });
      }
    });
  },
};
</script>
